<template>
    <div style="min-height: 75vh;">
        <story/>
        <leaders/>
    </div>
</template>

<script>
    import Story from "../components/aboutus/story";
    import Leaders from "../components/aboutus/leaders";
    export default {
        name: "About",
        components: {Leaders, Story}
    }
</script>

<style scoped>

</style>